type NotificationStore = {
  addNotification: (
    id: number,
    url: string | null,
    title: string,
    message: string,
    isError?: boolean
  ) => void;
};

type TargetValueChallenge = {
  targetValueType: string;
  targetValue: number;
  targetValueAchieved: boolean;
  userProgressSumCurrentInterval: number | null;
};

const TARGET_VALUE_TYPE_INTERVAL = "TARGET_TYPE_INTERVAL";

export function notifyIfTargetValueJustAchieved(
  notificationStore: NotificationStore,
  t: (key: string) => string,
  previousChallenge: TargetValueChallenge,
  challenge: TargetValueChallenge
): void {
  const wasTargetValueAchieved =
    challenge.targetValueType === TARGET_VALUE_TYPE_INTERVAL
      ? hasReachedTargetValue(
          previousChallenge.userProgressSumCurrentInterval,
          challenge.targetValue
        )
      : previousChallenge.targetValueAchieved;
  const isTargetValueAchieved =
    challenge.targetValueType === TARGET_VALUE_TYPE_INTERVAL
      ? hasReachedTargetValue(
          challenge.userProgressSumCurrentInterval,
          challenge.targetValue
        )
      : challenge.targetValueAchieved;

  if (wasTargetValueAchieved || !isTargetValueAchieved) {
    return;
  }

  notificationStore.addNotification(
    Date.now(),
    null,
    t("action.completion.notification.title"),
    t("action.completion.notification.targetValueAchieved"),
    false
  );
}

function hasReachedTargetValue(
  progress: number | null,
  targetValue: number
): boolean {
  return progress !== null && progress >= targetValue;
}
